import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { useAreaUIContext } from "../AreaUIContext";
import { AreaEditDialogHeader } from "./AreaEditDialogHeader";
import { AreaEditForm } from "./AreaEditForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/areaAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";

export const AreaEditDialog = ({ id, show, onHide }) => {
  // Area UI Context
  const areaUIContext = useAreaUIContext();
  const areaUIProps = useMemo(() => {
    return {
      initArea: areaUIContext.initArea,
      queryParams: areaUIContext.queryParams,
      setQueryParams: areaUIContext.setQueryParams,
    };
  }, [areaUIContext]);

  // Area Redux state
  const dispatch = useDispatch();
  const { actionsLoading, areaForEdit, error, roleMaster } = useSelector(
    (state) => ({
      actionsLoading: state.area.actionsLoading,
      areaForEdit: state.area.areaForEdit,
      roleMaster: state.area.roleMaster,
      error: state.area.error,
    }),
    shallowEqual
  );

  if (error) {
    toast.error(error, toastOption);
  }
  useEffect(() => {
    // server call for getting Area by id
    dispatch(actions.fetchArea(id));
  }, [id, dispatch]);

  const saveArea = (area) => {
    if (!id) {
      dispatch(actions.createArea(area)).then((response) => {
        if (response) toast.success(response.message, toastOption);
        dispatch(actions.fetchAreas(areaUIProps.queryParams)).then(() =>
          onHide()
        );
      });
    } else {
      dispatch(actions.updateArea(area)).then((response) => {
        if (response) toast.success(response.message, toastOption);
        dispatch(actions.fetchAreas(areaUIProps.queryParams)).then(() =>
          onHide()
        );
      });
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="modal-sizes-title-lg"
      size="lg"
    >
      <AreaEditDialogHeader id={id} />
      <AreaEditForm
        saveArea={saveArea}
        actionsLoading={actionsLoading}
        area={areaForEdit || areaUIProps.initArea}
        onHide={onHide}
        roleMaster={roleMaster}
        id={id}
      />
    </Modal>
  );
};
